export const SET_INFO_TYPES = 'SET_INFO_TYPES'